/**
 * 面部实时识别（面诊 type 1/4/6）
 *
 * 使用共享的 MediaPipe FaceDetection 单例（与 tongueDetector 共用）。
 * 检测画面中人脸位置 → 判断距离 → 自动触发拍照。
 */
import { getInstance, isLoaded as mpLoaded, prepareDetectInput, detectFace, judgeDistance, STATUS } from './mediapipeFace';

var _loaded = false;
var _loading = false;
var _loadPromise = null;

export { STATUS };

export function isLoaded() {
  return _loaded;
}

export function loadDetector() {
  if (_loaded) return Promise.resolve();
  if (_loading && _loadPromise) return _loadPromise;
  _loading = true;

  _loadPromise = new Promise(function (resolve, reject) {
    getInstance().then(function () {
      _loaded = true;
      _loading = false;
      _loadPromise = null;
      console.log('[FaceDetector] 面部检测模型就绪');
      resolve();
    }).catch(function (err) {
      _loading = false;
      _loadPromise = null;
      console.error('[FaceDetector] 初始化失败:', err && err.message || String(err));
      reject(err);
    });
  });
  return _loadPromise;
}

/**
 * 检测画面中的人脸位置和距离
 * @param {HTMLCanvasElement|HTMLVideoElement} source - 视频帧
 * @param {number} rotation - 旋转: 1=正常 2=90° 3=-90° 4=180°
 * @returns {Promise<{status: number}>}
 */
export function detect(source, rotation) {
  if (!_loaded || !mpLoaded()) {
    return Promise.resolve({ status: STATUS.NOT_DETECTED });
  }

  var sw = source.width || source.videoWidth || 0;
  var sh = source.height || source.videoHeight || 0;
  if (!sw || !sh) return Promise.resolve({ status: STATUS.NOT_DETECTED });

  // 降采样 + 旋转 → 小尺寸检测画布
  var detectCanvas = prepareDetectInput(source, rotation);
  if (!detectCanvas) return Promise.resolve({ status: STATUS.NOT_DETECTED });

  return detectFace(detectCanvas, 3000).then(function (results) {
    if (!results.detections || results.detections.length === 0) {
      return { status: STATUS.NOT_DETECTED };
    }
    return { status: judgeDistance(results.detections[0]) };
  }).catch(function (err) {
    console.warn('[FaceDetector] 检测出错:', err && err.message || String(err));
    return { status: STATUS.NOT_DETECTED };
  });
}
